module.exports = __webpack_public_path__ + "img/GALLERY-SCROSS-2.5abdb2f7.jpg";